import { useMutation } from '@tanstack/react-query'
import { useToast } from '@/hooks/useToast'
import { apiClient } from '@/lib/apiClient'

interface SubscribePayload {
  email: string
}

export function useNewsletterSubscription() {
  const { showToast } = useToast()

  const subscribeMutation = useMutation({
    mutationFn: async (payload: SubscribePayload) => {
      const response = await apiClient.post('/newsletter/subscribe', payload)
      return response.data
    },
    onSuccess: () => {
      showToast({
        type: 'success',
        message: 'Successfully subscribed to our newsletter!',
      })
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || 'Failed to subscribe to newsletter'
      showToast({
        type: 'error',
        message,
      })
    },
  })

  const unsubscribeMutation = useMutation({
    mutationFn: async (payload: SubscribePayload) => {
      const response = await apiClient.post('/newsletter/unsubscribe', payload)
      return response.data
    },
    onSuccess: () => {
      showToast({
        type: 'success',
        message: 'Successfully unsubscribed from newsletter',
      })
    },
    onError: (error: any) => {
      const message = error?.response?.data?.message || 'Failed to unsubscribe'
      showToast({
        type: 'error',
        message,
      })
    },
  })

  return {
    subscribe: subscribeMutation.mutateAsync,
    unsubscribe: unsubscribeMutation.mutateAsync,
    isSubscribing: subscribeMutation.isPending,
    isUnsubscribing: unsubscribeMutation.isPending,
  }
}
